import React from 'react';
import translationsJson from 'data/translations.json';
import info from 'data/info.json';
import { IconButton } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

const translations: Translations = translationsJson;

interface Props {
    data: any;
    category: string | undefined;
    title: string;
    name: string;
}

class ExcelExport extends React.Component<Props, { }> {
    private ExcelJS = require('exceljs');
    constructor(props: Props) {
        super(props);
        this.state = {
        }

        this.onClick = this.onClick.bind(this);
    }

    private async onClick() {
        
        const workbook = new this.ExcelJS.Workbook();
        const sheet = workbook.addWorksheet('Table');
        sheet.addTable({
            name: 'MyTable',
            ref: 'A4',
            headerRow: true,
            style: {
                theme: null,
                showRowStripes: false,
            },
            columns: [
              {name: translations.municipality[window.lang]},
              {name: translations.population[window.lang]},
              {name: translations.count[window.lang]},
              {name: translations.percent[window.lang]},
            ],
            rows: this.props.data,
          });
        const color = this.props.category === "f" ? "ffc5192d" : (this.props.category === "m" ? "ff19486a" : "ff3f7e44");
        sheet.mergeCells('A1:D1');
        sheet.getCell('A1').value = translations.astat[window.lang];
        sheet.getCell('A1').font = {bold: true}
        sheet.mergeCells('A2:D2');
        sheet.getCell('A2').value = this.props.title;
        sheet.getCell('A2').font = {bold: true, size: 20, color: {argb: color}}
        sheet.getCell('A4').fill = { type: 'pattern', pattern:'solid', fgColor: {argb: color} }
        sheet.getCell('B4').fill = { type: 'pattern', pattern:'solid', fgColor: {argb: color} }
        sheet.getCell('C4').fill = { type: 'pattern', pattern:'solid', fgColor: {argb: color} }
        sheet.getCell('D4').fill = { type: 'pattern', pattern:'solid', fgColor: {argb: color} }
        sheet.getCell('A4').font = { color: {argb: "ffffffff"} }
        sheet.getCell('B4').font = { color: {argb: "ffffffff"} }
        sheet.getCell('C4').font = { color: {argb: "ffffffff"} }
        sheet.getCell('D4').font = { color: {argb: "ffffffff"} }
        sheet.getColumn(1).width = 25;
        sheet.getColumn(2).width = 20;
        sheet.getColumn(3).width = 20;
        sheet.getColumn(4).width = 20;
        const name = this.props.name;
        const version = "V" + ((this.props.category === "f" || this.props.category === "m") ? info.firstnamesYear : info.lastnamesYear);
        workbook.xlsx.writeBuffer( {
            base64: true
        }).then( function (xls64 : any) {
            // build anchor tag and attach file (works in chrome)
            var a = document.createElement("a");
            var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

            var url = URL.createObjectURL(data);
            a.href = url;
            a.download = "ASTAT_" + version + "_" + name + "_" + window.lang.toUpperCase() + ".xlsx";
            document.body.appendChild(a);
            a.click();
            setTimeout(function() {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);
                }, 
                0
            );
        }).catch(function(error : any) {
            console.log(error.message);
        });
    }

    render() {
        return (
            <IconButton color="primary" className="button" onClick={this.onClick}>
                <DownloadIcon />
            </IconButton>);
    }
}

export default ExcelExport;